<template>
	<!-- 投注组件 -->
	<div class="twenty_record_box">
		<div class="twenty_record_bg">
			<!-- PC蛋蛋投注卡 -->
			<div v-if="gameindex == 5" class="twenty_recode_main box_h">
				<div class="twenty_recode_listbox box_flex">
					<div class="twenty_recode_border xinyun">
						<span>玩法</span>
						<span>赔率</span>
						<span>投注金额</span>
						<span>预期奖金</span>
					</div>
					<div class="twenty_recode_list xinyun_padding">
						<template v-if="betary.length > 0">
							<div class="twenty_recode_item border_none" v-for="(item, index) in betary" :key="index">
								<div class="box_flex xinyun">
									<div class="recode_name">[{{ item.name }}]</div>
									<div class="recode_name">赔率：{{ item.odds }}</div>
									<div>{{ item.mount }}</div>
									<div>{{ item.mount * item.odds }}元</div>
								</div>
							</div>
						</template>
						<template v-else>
							<div class="twenty_recode_none"><span class="iconfont icon-biaodan"></span>暂无数据</div>
						</template>
					</div>
				</div>
				<div class="twenty_recode_btnbox">
					<div class="confirm_bet_info">确认投注信息</div>
					<div class="comput_box">
						<p class="comput_m">
							共计&ensp;<strong>{{ allNum }}</strong
							>&ensp;注
						</p>
						<p class="comput_m">
							总&ensp;<strong>{{ money }}</strong
							>&ensp;元
						</p>
					</div>
					<div class="comput_box">
						<p class="comput_m">
							可用余额:&ensp;<strong>{{ balance }}</strong
							>&ensp;元
						</p>
					</div>
					<a href="javascript:void(0)" class="recode_sure_submit" @click="listBtnClick">
						<div>确定投注</div>
						<!-- <div class="line"></div> -->
						<p>{{ timeh }}:{{ timem }}:{{ times }}</p>
					</a>
					<el-row type="flex" class="row-bg" justify="space-between">
						<el-button type="default" size="small" icon="el-icon-delete" @click="deletNum">清空</el-button>
					</el-row>
				</div>
			</div>
			<!-- 其他玩法投注卡 -->
			<div class="twenty_recode_main box_h" v-else>
				<div class="twenty_recode_listbox box_flex">
					<div class="twenty_recode_border">
						<span class="item_name">玩法</span>
						<span class="item_content">投注内容</span>
						<span class="item_class">模式</span>
						<span class="item_p">奖金返点</span>
						<span class="item_num">注数</span>
						<span class="item_num">倍数</span>
						<span class="item_mount">投注金额</span>
						<span class="item_clear">清空</span>
					</div>
					<div class="twenty_recode_list">
						<template v-if="betary.length > 0">
							<div class="twenty_recode_item" v-for="(item, index) in betary" :key="index">
								<div class="box_flex box_h">
									<div class="item_name">[{{ item.name }}]</div>
									<div class="item_content" :title="TextJoin == true ? item.GAry.join(',') : item.GAry.join(' ')">
										{{ TextJoin == true ? item.GAry.join(",") : item.GAry.join(" ") }}
									</div>
									<div class="item_class">{{ item.type }}模式</div>
									<div class="item_p">
										<span>{{ item.Odds }}</span
										>%
									</div>
									<div class="item_num">
										<span>{{ item.num }}</span
										>注
									</div>
									<div class="item_num">
										<span>{{ item.GMult }}</span
										>倍
									</div>
									<div class="item_mount">
										<span>{{ item.mount }}</span
										>元
									</div>
									<div class="recode_deleted" :data-id="index" @click="deleteOne">
										<i class="el-icon-circle-close"></i>
									</div>
								</div>
							</div>
						</template>
						<template v-else>
							<div class="twenty_recode_none"><span class="iconfont icon-biaodan"></span>暂无数据</div>
						</template>
					</div>
				</div>
				<div class="twenty_recode_btnbox">
					<div class="confirm_bet_info">确认投注信息</div>
					<div class="comput_box">
						<p class="comput_m">
							共计&ensp;<strong>{{ allNum }}</strong
							>&ensp;注
						</p>
						<p class="comput_m">
							共&ensp;<strong>{{ money }}</strong
							>&ensp;元
						</p>
					</div>
					<div class="comput_box">
						<p class="comput_m">
							可用余额:&ensp;<strong>{{ balance }}</strong
							>&ensp;元
						</p>
					</div>
					<a href="javascript:void(0)" class="recode_sure_submit" @click="listBtnClick">
						<div>确定投注</div>
						<p>{{ timeh }}:{{ timem }}:{{ times }}</p>
					</a>
					<el-row type="flex" class="row-bg" justify="space-between">
						<el-button type="default" class="note" size="small" @click="setNum">设置追号</el-button>
						<el-button type="default" class="clear" size="small" @click="deletNum">清空</el-button>
					</el-row>
				</div>
			</div>
		</div>
		<OrderConfirm
			ref="OrderConfirm"
			:cz="cz"
			:qh="qh"
			:money="money"
			:shTextArr="shText"
			:all-num="allNum"
			:confirm="confirmOrder"
		></OrderConfirm>
	</div>
</template>
<script>
import OrderConfirm from "@/components/Elasticframe/OrderConfirm.vue";

export default {
	components: { OrderConfirm },
	props: {
		betary: {
			type: Array,
			required: true,
		},
		gameindex: {
			type: String,
			required: true,
		},
		ids: {
			type: Number,
			required: true,
		},
		time: {
			type: Object,
			required: true,
		},
	},
	data() {
		return {
			cz: "",
			qh: "",
			money: 0,
			shText: [],
			TextJoin: true,
			allNum: 0, //总注数
			countTime: 0,
			timeh: "00",
			timem: "00",
			times: "00",
			setDateFun: null,
		};
	},
	watch: {
		betary: function (val) {
			this.shText = [];
			let money = 0;
			let num = 0;
			this.betary.forEach(item => {
				num += Number(item.num == undefined ? 1 : item.num);
				money += Number(item.mount);
				if (this.gameindex == 5) {
					this.shText.push(`[${item.name}]`);
				} else {
					this.shText.push(`[${item.name}] ${this.TextJoin == true ? item.GAry.join(",") : item.GAry.join(" ")}`);
				}
			});
			this.money = money.toFixed(3);
			this.allNum = num;
		},
		time(val) {
			clearInterval(this.setDateFun);
			this.countTime = val.time || 0;
			this.setInervalue();
			this.sscopenTimeDispose();
		},
	},
	created() {
		window.eventBus.$on("newVersionAddNum", () => {
			this.changeNum();
		});
	},
	computed: {
		navAry() {
			return this.$store.state.navAry;
		},
		balance() {
			return this.$store.state.userInfo.Balance;
		},
	},
	methods: {
		//生成时间执行
		sscopenTimeDispose() {
			let that = this;
			that.setDateFun = setInterval(() => {
				let num = Number(that.countTime);
				if (num > 0) {
					that.countTime -= 1;
					that.setInervalue();
				} else {
					clearInterval(this.setDateFun);
					that.setDateFun = null;
				}
			}, 1000);
		},
		//时间处理
		setInervalue() {
			let that = this;
			let num = Number(that.countTime);
			let h = Math.floor(num / 3600);
			that.timeh = h < 10 ? "0" + h : h; //小时
			let m = Math.floor(num / 60) - h * 60; //分钟
			that.timem = m < 10 ? "0" + m : m;
			that.times = Number(num % 60) < 10 ? "0" + Number(num % 60) : Number(num % 60); //秒
		},
		confirmOrder() {
			this.$emit("direct");
		},
		// 列表投注
		listBtnClick() {
			if (this.betary.length == 0) {
				this.$emit("direct");
				return;
			}
			this.cz = window.lgText;
			this.navAry.map(item => {
				item.LotteryList.map(v => {
					if (v.LsId == this.$router.currentRoute.query.index && v.LgId == this.$router.currentRoute.query.id) {
						this.cz = v.Name;
					}
				});
			});
			this.qh = `${window.NowLssue} 期`;

			this.$refs.OrderConfirm.show();
		},
		// 一键梭哈
		allBet() {
			window.eventBus.$emit("addNum2Allin");
		},
		// 运行父组件添加到投注卡的方法
		changeNum() {
			if ([67, 64, 62, 173, 169, 2, 14, 20, 26, 31, 33, 38, 40, 45, 47, 50].includes(this.ids)) {
				this.TextJoin = false;
			} else this.TextJoin = true;
			if (!this.getChildData || this.getChildData.length == 0) {
				this.$emit("addnum");
				return false;
			}
			let printData = [];
			this.getChildData.forEach(function (element, index) {
				let oneData = [];
				element.value.forEach(function (el, inx) {
					oneData.push(el.value);
				});
				printData[element.key - 1] = oneData.join("");
			});
			this.$message.error(printData.join(","));
		},
		//清空投注卡列表
		deletNum() {
			this.$emit("emptynum", []);
		},
		//删除投注卡某一列
		deleteOne(e) {
			let index = e.currentTarget.dataset.id;
			this.$emit("deletenum", index);
		},
		//设置追号
		setNum() {
			let that = this;
			if (that.gameindex == 5) {
				this.$emit("openmess", "该玩法暂不支持追号");
			} else {
				this.$emit("settrack");
			}
		},
		// 输入修改投注金额
		UserInput(e) {
			this.$emit("chinput");
		},
	},
};
</script>
<style>
/* 投注记录 */
.twenty_record_box {
	width: 100%;
}

.twenty_record_bg {
	border-radius: 2px;
	-webkit-border-radius: 2px;
	width: 100%;
}

.twenty_recode_main {
	position: relative;
}

.twenty_recode_listbox {
	position: relative;
	width: 100%;
	margin-right: 20px;
	height: 244px;
	padding-top: 34px;
	border-radius: 4px;
	overflow: hidden;
}

.twenty_recode_border {
	position: absolute;
	top: 0;
	left: 0;
	display: flex;
	justify-content: space-around;
	align-items: center;
	width: 100%;
	height: 36px;
	border-radius: 12px 12px 0 0;
	overflow: hidden;
}

.twenty_recode_border > span {
	width: 100%;
	height: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
	background-color: #6455fe;
	font-size: 14px;
	font-weight: normal;
	font-stretch: normal;
	letter-spacing: normal;
	color: #fff;
	border: 1px solid rgba(236, 238, 242, 0.6);
	border-right: none;
}
.twenty_recode_border > span:last-child {
	border-right: 1px solid rgba(236, 238, 242, 0.6);
}
.twenty_recode_item .item_name,
.twenty_recode_border .item_name {
	width: 166px;
}
.twenty_recode_item .item_content,
.twenty_recode_border .item_content {
	width: 140px;
}
.twenty_recode_item .item_class,
.twenty_recode_border .item_class {
	width: 80px;
}
.twenty_recode_item .item_p,
.twenty_recode_border .item_p {
	flex: 1;
}
.twenty_recode_item .item_num,
.twenty_recode_border .item_num {
	width: 60px;
}
.twenty_recode_item .item_mount,
.twenty_recode_border .item_mount {
	width: 120px;
}
.twenty_recode_item .recode_deleted,
.twenty_recode_border .item_clear {
	width: 65px;
}

.xinyun {
	justify-content: space-around !important;
}

.xinyun > div,
.xinyun > span {
	width: 25%;
	text-align: center;
}

.twenty_recode_list {
	background: #fff;
	height: 100%;
	overflow-y: auto;
	box-sizing: border-box;
}

.twenty_recode_item {
	display: flex;
	justify-content: space-around;
	white-space: nowrap;
	line-height: 31px;
	height: 31px;
	overflow: hidden;
	color: #666666;
	font-size: 14px;
}

.twenty_recode_item .item_name,
.twenty_recode_item .item_content,
.twenty_recode_item .item_class,
.twenty_recode_item .item_p,
.twenty_recode_item .item_num,
.twenty_recode_item .item_mount,
.twenty_recode_item .recode_deleted {
	border-left: 1px solid rgba(236, 238, 242, 0.6);
	border-bottom: 1px solid rgba(236, 238, 242, 0.6);
	color: #888888;
	font-family: PingFangSC;
	font-size: 13px;
	height: 100%;
}
.twenty_recode_item .recode_deleted {
	border-right: 1px solid rgba(236, 238, 242, 0.6);
}

.twenty_recode_item:nth-child(even) {
	background: #f5f7f7;
}

.twenty_recode_item:last-child {
	border-color: transparent;
}

.twenty_recode_none {
	width: 100%;
	height: 100%;
	font-size: 14px;
	font-weight: normal;
	font-stretch: normal;
	padding-top: 20px;
	letter-spacing: 1px;
	color: #a0a0a0;
	text-align: center;
}

.twenty_recode_none > span {
	display: block;
	height: 92px;
	font-size: 40px;
	color: #d2d2d2;
	margin: 30px 0 8px;
	background: url("../../static/img/lottery/twenty_recode_none.png") no-repeat center;
}

.twenty_recode_none > span:before {
	display: none;
}

.recode_name {
	overflow: hidden;
}

.recode_name:first-child {
	text-overflow: ellipsis;
	white-space: nowrap;
	overflow: hidden;
}

.item_name {
	width: 112px;
	text-align: center;
}

.item_content {
	width: 164px;
	text-align: center;
	overflow: hidden;
	white-space: nowrap;
	text-overflow: ellipsis;
}
.item_content,
.item_p > span,
.item_num > span,
.item_mount > span {
	font-family: "HiraginoSansGB-W3";
}
.item_class {
	width: 70px;
	text-align: center;
}

.item_p {
	width: 104px;
	text-align: center;
}

.item_num {
	width: 60px;
	text-align: center;
}

.item_mount {
	width: 73px;
	text-align: center;
}

.twenty_recode_item > div:first-child {
	display: flex;
	justify-content: space-between;
	align-items: center;
	width: 607px;
}

.gameinfo4 {
	min-width: 90px;
	text-align: center;
}

.recode-last-mount {
	padding: 0 20px;
	text-align: right;
}

.recode-last-mount > input {
	width: 80px;
	border: none;
	outline: none;
	text-align: center;
	border-bottom: 1px solid #dedfe5;
	margin: 0 5px;
}

.recode_otherinfo {
	margin-right: 30px;
}

.recode_deleted {
	height: 38px;
	width: 30px;
	cursor: pointer;
	display: flex;
	align-items: center;
	justify-content: center;
}

.recode_deleted .el-icon-circle-close {
	font-size: 20px;
	vertical-align: middle;
	color: #0e78c7;
}

.recode_deleted:hover .el-icon-circle-close {
	color: red;
}

.twenty_recode_btnbox {
	width: 320px;
	overflow: hidden;
	padding: 18px 18px 15px;
	border: 1px solid #f2f2f2;
	border-radius: 12px;
	box-shadow: inset 1.5px 2.6px 3px 0 rgba(0, 0, 0, 0.08);
	background-image: linear-gradient(to top, #edf0fa, #fefdfd);
}

.twenty_recode_btnbox .confirm_bet_info {
	color: #555;
	font-family: PingFangSC;
	font-weight: normal;
	font-size: 18px;
	display: flex;
	align-items: center;
}

.twenty_recode_btnbox .confirm_bet_info:before {
	content: "";
	display: inline-block;
	width: 24px;
	height: 24px;
	margin-right: 12px;
	background: url("~@/static/img/lottery/money.png") no-repeat center/cover;
}

.twenty_recode_btnbox .comput_box {
	display: flex;
	justify-content: space-between;
	padding: 10px 0;
	border-bottom: 1px solid #ccc;
	border-image: linear-gradient(to right, transparent 0%, #ccc 50%, transparent);
	border-image-slice: 1;
}

.twenty_recode_btnbox .comput_box > div {
	width: 50%;
}

.comput_m {
	font-size: 16px;
	color: #555;
	font-family: PingFangSC;
}

.comput_m strong {
	color: #e9537a;
	font-weight: normal;
}

.twenty_recode_btnbox button {
	width: 132px;
	height: 32px;
	padding: 0;
	margin-top: 10px;
	cursor: pointer;
	border-radius: 8px;
	border: none;
	box-shadow: 0px 1px 3px 0 rgba(0, 0, 0, 0.25);
	background-image: linear-gradient(to top, #edf0fa, #fff);
}

.twenty_recode_btnbox button.note::before {
	content: "";
	display: inline-block;
	vertical-align: middle;
	background-image: url("~@/static/img/icon/note.png");
	background-repeat: no-repeat;
	width: 18px;
	height: 20px;
	background-size: 100%;
}
.twenty_recode_btnbox button.clear::before {
	content: "";
	display: inline-block;
	vertical-align: middle;
	background-image: url("~@/static/img/icon/trash.png");
	background-repeat: no-repeat;
	width: 14px;
	height: 20px;
	background-size: 100%;
}

.twenty_recode_btnbox button span {
	color: #555;
	font-family: PingFangSC;
	font-size: 14px;
	vertical-align: middle;
	margin-left: 5px;
}

a.recode_sure_submit {
	display: flex;
	justify-content: center;
	align-items: center;
	width: 100%;
	height: 49px;
	margin-top: 10px;
	background-image: url("~@/static/img/lottery/confirm-btn.png");
	background-size: contain;
	background-repeat: no-repeat;
	letter-spacing: 1px;
}

a.recode_sure_submit > * {
	font-size: 18px;
	color: #ffffff;
	font-weight: 400;
	flex: 1;
	justify-content: center;
	display: flex;
}

a.recode_sure_submit > div {
	font-family: PingFangSC;
}

a.recode_sure_submit > p {
	font-family: Arial;
}

.xinyun_padding {
	padding: 0;
}

.border_none {
	border: none;
}
</style>



// WEBPACK FOOTER //
// src/components/Subcomponents/Betting.vue